import service from "@irati/utils/tracking/index"
import {getTrackingProductName} from "@irati/utils/tracking/products"

const tracking = {
  clickWalletBalance: (balance: number, currency: string, source?: string) => {
    const data = {
      balance,
      currency,
      source,
      perkbox_product: getTrackingProductName()
    }
    service.trackWalletEvent("platform_click_wallet_balance", data)
  },
  viewWallets: () => {
    service.trackWalletEvent("view_wallets")
  },
  viewHome: () => {
    service.trackWalletEvent("perksgo_view_wallet")
  },
  clickBrowsePerks: () => {
    service.trackWalletEvent("my_wallet_click_flexi_points_cta", {
      type: "Browse_perks"
    })
  },
  clickBrowseRewards: (source?: string) => {
    const data = {
      source
    }
    service.trackWalletEvent("perksgo_click_browse_rewards", data)
  },
  clickBrowseWellness: () => {
    service.trackWalletEvent("my_wallet_click_flexi_points_cta", {
      type: "Browse_wellness"
    })
  },
  clickLinkCard: () => {
    service.trackWalletEvent("perksgo_click_home_link_card")
  },
  clickFaqs: () => {
    service.trackWalletEvent("perksgo_click_faqs")
  },
  clickGoToMyWallet: () => {
    service.trackOnboardingEvent("onboarding_nav_wallet")
  },
  clickDone: (tenantId: string) => {
    const data = {
      tenantId
    }
    service.trackOnboardingEvent("Flexi_Points_Onboarding_Done", data)
  },
  clickTreatTokenCard: (tenantId: string) => {
    const data = {
      tenantId
    }
    service.trackWalletEvent("discover_flexi_points", data)
  },
  clickRewardPointsCard: (tenantId: string) => {
    const data = {
      tenantId
    }
    service.trackWalletEvent("discover_reward_points", data)
  },
  viewEarnPointsModal: () => {
    service.trackWalletEvent("earn_view_modal_perk_desc")
  },
  viewEarnPointsTooltip: () => {
    if (window.location.href.includes("perks/info")) {
      // Perks Info page (important info or header badge on mobile)
      service.trackWalletEvent("earn_view_tooltip_perk_desc")
    } else {
      // Perk cards on the homepage
      service.trackWalletEvent("earn_view_tooltip_perk_homepage")
    }
  }
}

export default tracking
